import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewGanttModule"
const debug = false

export class ViewGanttModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_TABLE, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Gantt"
        this.description                = "The Gantt module offers a powerful tool for visualizing project timelines and dependencies. It provides users with an interactive Gantt chart that displays tasks, milestones, and project progress over time. With customizable settings and drag-and-drop functionality, users can easily adjust task durations, dependencies, and priorities directly within the Gantt chart. The module enhances project planning and management by providing a visual representation of project schedules, helping teams stay organized and on track to meet deadlines."
        this.svgIcon                    = "isvg-view-gantt"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-gantt"

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.parentSection              = SettingsParentSection.VIEWS

        this.feature                    = Feature.GANTT
        this.validateFeature()

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}